// src/redux/actions/cardActions.js
import axios from "axios";
import { CARD_ACTIONS as TYPES } from "../../actions/chatbotActions/chatbotActionTypes";
import { apicall } from "../../../services/api";
import { toast } from "react-hot-toast";
const BASE_URL = "chatbot/card-type";

// Fetch all card types
export const fetchCards = (update = false) => async (dispatch, getState) => {
  dispatch({ type: TYPES.FETCH_REQUEST });

  if (update) {
    if (getState().cardReducer?.cards?.data?.length > 0) {
      dispatch({ type: TYPES.FETCH_SUCCESS, payload: getState().cardReducer?.cards });
      return;
    }
  }

  try {
    const res = await apicall(`${BASE_URL}`, "get", {}, {}, "v3");
    dispatch({ type: TYPES.FETCH_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.FETCH_FAILURE, payload: err.message });
  }
};

// Fetch card type by ID
export const fetchCardById = (id) => async (dispatch) => {
  dispatch({ type: TYPES.FETCH_BY_ID_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/${id}`, "get", {}, {}, "v3");
    dispatch({ type: TYPES.FETCH_BY_ID_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.FETCH_BY_ID_FAILURE, payload: err.message });
  }
};

// Add new card type
export const addCard = (data) => async (dispatch) => {
  dispatch({ type: TYPES.ADD_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/`, "post", data, {}, "v3");
    toast.success(res?.data?.message);
    dispatch(fetchCards());
    dispatch({ type: TYPES.ADD_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.ADD_FAILURE, payload: err.message });
  }
};

// Update card type
export const updateCard = (id, data) => async (dispatch) => {
  dispatch({ type: TYPES.UPDATE_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/${id}`, "patch", data, {}, "v3");
    toast.success(res?.data?.message);
    dispatch(fetchCards());
    dispatch({ type: TYPES.UPDATE_SUCCESS, payload: res.data });
  } catch (err) {
    toast.error(err.message || "Failed to update card");
    dispatch({ type: TYPES.UPDATE_FAILURE, payload: err.message });
  }
};

// Delete card type
export const deleteCard = (id) => async (dispatch) => {
  dispatch({ type: TYPES.DELETE_REQUEST });
  try {
    await apicall(`${BASE_URL}/${id}`, "delete", {}, {}, "v3");
    dispatch(fetchCards());

    toast.success("Card type deleted successfully");
    dispatch({ type: TYPES.DELETE_SUCCESS, payload: id });
  } catch (err) {
    dispatch({ type: TYPES.DELETE_FAILURE, payload: err.message });
  }
};
